import React from 'react';
import { Bell } from 'lucide-react';
import NotificationDropdown from './NotificationDropdown';

const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

/** Global announcements feed (GlobalNotification endpoints). */
const NotificationWindow = ({ userId }) => {
  const source = {
    title: 'Announcements',
    icon: Bell,
    enabled: !!userId,
    listUrl: (pageNum, type) =>
      `${apiBaseUrl}/GlobalNotification/${userId}/all?pageNumber=${pageNum}&pageSize=10&type=${type}`,
    extractList: (response) => response.data.data?.data,
    countUrl: () => `${apiBaseUrl}/GlobalNotification/${userId}/unread/count`,
    markReadUrl: (id) => `${apiBaseUrl}/GlobalNotification/${userId}/markAsRead?notificationId=${id}`,
    getId: (notification) => notification.notificationId,
  };

  return <NotificationDropdown source={source} />;
};

export default NotificationWindow;
